import gql from 'graphql-tag';
import { query, mutate } from '@/api/graphql';

import { apolloClientQueryCacheOption } from '@/api/constants';
import GetSites from './graphql/queries/getSites.graphql';
import GetSite from './graphql/queries/getSite.graphql';
import GetSiteSettings from './graphql/queries/getSiteSettings.graphql';
import SaveSiteTurboAdvertisement from './graphql/mutations/SaveSiteTurboAdvertisement.graphql';
import Site from './graphql/fragments/site.graphql';
import settings from './graphql/fragments/settings.graphql';

export const fetchSites = async () => {
  const { sites } = await query(gql`
    ${GetSites}
    ${Site}
    ${settings}
  `, null, apolloClientQueryCacheOption);

  return sites;
};

export const fetchSite = async id => {
  const { site } = await query(gql`
    ${GetSite}
    ${Site}
    ${settings}
  `, { id }, apolloClientQueryCacheOption);

  return site;
};

export const getSiteSettings = async (id, options = apolloClientQueryCacheOption) => {
  const { site } = await query(gql`${GetSiteSettings} ${settings}`, { id }, options);

  return site.settings;
};

export const saveSiteTurboAdvertisement = async (id, turboAdvertisement) => {
  const result = await mutate(gql`${SaveSiteTurboAdvertisement}`, { id, turboAdvertisement });

  return result?.saveSiteTurboAdvertisement;
};
